import Api from "@services/api";
import { IRequestContact } from "../models/type";

export const postRequestContact = async (payload: IRequestContact) => {
  const res = await Api().post("/contact-form-send-email", payload, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  return res.data;
};
